import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { SignalRService } from 'app/core/services/signal-r.service';
import { IHubConnection, ISignalRError } from 'app/core/interfaces/signal.interface';

@Injectable()
export class SignalRFacadeService {
  private readonly connectionSubject = new ReplaySubject<IHubConnection | ISignalRError | null>(1);
  private referenceCount = 0;
  private isStarting = false;
  private hasActiveConnection = false;
  private stopTimeout: any;


  constructor(private signalRService: SignalRService) {}

  watchConnection$(): Observable<IHubConnection | ISignalRError | null> {
    return new Observable((observer) => {
      this.referenceCount += 1;

      if (this.stopTimeout) {
        clearTimeout(this.stopTimeout);
        this.stopTimeout = null;
      }

      if (this.referenceCount === 1) {
        this.startConnection();
      }

      const sub = this.connectionSubject
        .filter((conn) => conn !== null)
        .subscribe(observer);

      return () => {
        sub.unsubscribe();
        this.referenceCount = Math.max(0, this.referenceCount - 1);

        if (this.referenceCount === 0) {
          this.stopTimeout = setTimeout(() => {
            this.stopConnection();
            this.stopTimeout = null;
          }, 5000);
        }
      };
    });
  }

  private stopConnection(): void {
    this.hasActiveConnection = false;
    this.isStarting = false;
    this.signalRService.stop();
    this.connectionSubject.next(null);
  }

  registerHubConnection(hub: string, remainingUrl?: string): Observable<void> {
    return this.signalRService.registerHubConnection(hub, remainingUrl);
  }

  deleteHubConnection(hub: string, remainingUrl?: string): Observable<void> {
    return this.signalRService.deleteHubConnection(hub, remainingUrl);
  }

  subscribeTo(method: string, callback: (...args: any[]) => void): void {
    this.signalRService.unsubscribeTo(method);
    this.signalRService.subscribeTo(method, callback);
  }

  unsubscribeTo(method: string): void {
    this.signalRService.unsubscribeTo(method);
  }

  private startConnection(): void {
    if (this.isStarting || this.hasActiveConnection) {
      return;
    }
    this.isStarting = true;
    this.signalRService
      .start()
      .then((connection) => {

        if (this.referenceCount === 0) {
          this.signalRService.stop();
          this.hasActiveConnection = false;
          return;
        }
        this.hasActiveConnection = true;
        this.connectionSubject.next(connection);
      })
      .catch((error) => {
        this.hasActiveConnection = false;
        this.connectionSubject.next({
          message: 'Connection error',
          code: error.status || 'FAIL',
        });
      })
      .then(() => {
        this.isStarting = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/signal-r-facade.service.ts